import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DwMediaRepositoryService } from '@devwareapps/devware-cap';

@Component({
  selector: 'app-aviator-avatar',
  templateUrl: './aviator-avatar.component.html',
  styleUrls: ['./aviator-avatar.component.scss']
})
export class AviatorAvatarComponent implements OnInit, OnChanges {
  @Input() firstName: string;
  @Input() lastName: string;
  @Input() fullName: string;
  @Input() userImageMediaPath: string;

  @Input() size: number = 40;

  avatarInitialsStyle: any = {
    width: this.size + 'px',
    height: this.size + 'px',
  }

  initials: string;
  imageUrl: string;
  defaultImageUrl : string = '/assets/img/user-avatar2.png';
  avatarClassName: string = 'avatar-image';
  imageSizePx: string = this.size + 'px';

  constructor(private dwMediaRepository: DwMediaRepositoryService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setupUserInitials();

    this.setupMediaPathUrl();
  }

  setupMediaPathUrl() {
    if (this.userImageMediaPath) {
      this.imageUrl = this.dwMediaRepository.getImageUrlFromMediaPath(this.userImageMediaPath, this.size, this.size);

      this.imageSizePx = this.size + 'px';
    }
  }

  setupUserInitials() {

    this.avatarInitialsStyle = {
      width: this.size + 'px',
      height: this.size + 'px',
    };
    
    if (this.firstName && this.lastName) {
      this.initials = this.firstName.charAt(0).toUpperCase() + this.lastName.charAt(0).toUpperCase();
      return;
    }

    if (this.fullName) {
      const names = this.fullName.split(' ');
      if (names.length >= 2) {
        this.initials = names[0].charAt(0).toUpperCase() + names[1].charAt(0).toUpperCase();
        return;
      } else if (names.length === 1) {
        this.initials = names[0].charAt(0).toUpperCase();
        return;
      }
    }
    
    this.initials = 'AV'; // Aviator User? fallback
  }
}
